export const HEADER_TITLE = "Club Sports Solutions";
export const CONTACT_NUMBER = "+1 210-636-2804";
export const FACEBOOK_LINK = "https://www.facebook.com/company/trunk-soft/";
export const INSTAGRAM_LINK = "https://www.instagram.com/company/trunk-soft/";
export const WATSAPP_LINK = "shorturl.com/cccccccc";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/trunk-soft/";
export const TWITTER_LINK = "https://www.twitter.com/company/trunk-soft/";